import { VesselMessage } from '../../types/VesselMessage';
import { GetPaginatedVesselsParams } from '../common/api/clients/gateway.api';
import { queries } from '../common/api/queryKeys/queries';
import { usePaginationQuery } from '../common/hooks/usePaginationQuery';

export const useVesselPagination = (params: GetPaginatedVesselsParams) => {
    const query = queries.vessels.pagination(params);
    const nextPageQuery = queries.vessels.pagination({ ...params, page: params.page + 1 });

    return usePaginationQuery<VesselMessage>({
        queryKey: query.queryKey,
        queryFn: query.queryFn,
        prefetchQueryKey: nextPageQuery.queryKey,
        prefetchQueryFn: nextPageQuery.queryFn,
    });
};
